import { Page } from "src/app/core/models/page";

export class ReceivingInstructionDetailRequest extends Page {
  adNo?: string;

  constructor() {
    super();
    this.adNo = undefined;
  }
}
